import Vue from 'vue';
import Router from 'vue-router';
import jwtDecode from 'jwt-decode';
import DateUtils from '@/utils/date';

import UserCreate from '@/components/admin/UserCreate';
import UserEdit from '@/components/admin/UserEdit';
import UserProfile from '@/components/user/Profile';

import DocumentList from '@/components/user/DocumentList';
import AdminMarketDocumentList from '@/components/admin/AdminMarketDocumentList';
import AdminFaqDocumentList from '@/components/admin/AdminFaqDocumentList';
import MarketDocumentList from '@/components/user/MarketDocumentList';
import FaqDocumentList from '@/components/user/FaqDocumentList';
import TemplateList from '@/components/user/TemplateList';
import FileList from '@/components/user/FileList';
import TopicList from '@/components/user/TopicList';
import PostList from '@/components/user/PostList';
import UserLayout from '@/components/layouts/UserLayout';
import AdminLayout from '@/components/layouts/AdminLayout';
import UserList from '@/components/admin/UserList';
import Mail from '@/components/admin/mail/Index';
import BoardList from '@/components/admin/BoardList';
import ActiveAccount from '@/components/ActiveAccount';
import ForgetPassword from '@/components/ForgetPassword';
import ResetPassword from '@/components/ResetPassword';
import ChangePassword from '@/components/ChangePassword';
import Login from '@/components/Login';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
  {
    path: '/',
    redirect: '/user/profile',
  },
  {
    path: '/login',
    component: Login,
    meta: {
      noNeedGuard: true,
    },
  },
  {
    path: '/forget',
    component: ForgetPassword,
    meta: {
      noNeedGuard: true,
    },
  },
  {
    path: '/reset',
    component: ResetPassword,
    meta: {
      noNeedGuard: true,
    },
  },
  {
    path: '/admin',
    component: AdminLayout,
    redirect: '/admin/list/1',
    children: [
    {
      path: 'list/:page',
      component: UserList,
    },
    {
      path: 'create',
      component: UserCreate,
    },
    {
      path: ':userID/profile',
      component: UserEdit,
    },
    {
      path: 'markets',
      component: AdminMarketDocumentList
    },
    {
      path: 'faqs',
      component: AdminFaqDocumentList
    },
    {
      path: ':userID/documents',
      component: DocumentList,
    },
    {
      path: ':userID/markets',
      component: MarketDocumentList,
    },
    {
      path: ':userID/faqs',
      component: FaqDocumentList,
    },
    {
      path: ':userID/files',
      component: FileList,
    },
    {
      path: ':userID/topics',
      component: TopicList,
    },
    {
      path: ':userID/posts/:topicID',
      component: PostList,
    },
    {
      path: ':userID/templates',
      component: TemplateList,
    },
    {
      path: ':userID/password',
      component: ChangePassword,
    },
    {
      path: 'mail',
      component: Mail,
    },
    {
      path: 'boards',
      component: BoardList,
    },
    ],
  },
  {
    path: '/user',
    component: UserLayout,
    redirect: `/user/${localStorage.userID}/profile`,
    children: [
    {
      path: ':userID/profile',
      component: UserProfile,
    },
    {
      path: ':userID/documents',
      component: DocumentList,
    },
    {
      path: ':userID/markets',
      component: MarketDocumentList,
    },
     {
      path: ':userID/faqs',
      component: FaqDocumentList,
    },
    {
      path: ':userID/files',
      component: FileList,
    },
    {
      path: ':userID/templates',
      component: TemplateList,
    },
    {
      path: ':userID/topics',
      component: TopicList,
    },
    {
      path: ':userID/posts/:topicID',
      component: PostList,
    },
    {
      path: 'active',
      component: ActiveAccount,
      meta: {
        noNeedGuard: true,
      },
    },
    {
      path: ':userID/password',
      component: ChangePassword,
    },
    ],
  },
  ],
});

const redirectToLoginPage = (next) => {
  next({
    path: '/login',
  });
};

const checkTokenStatus = (to, from, next, decodedToken) => {
  if (!decodedToken || decodedToken.exp < DateUtils.unix()) {
    redirectToLoginPage(next);
  } else next();
};

/**
 * 1 => Admin
 * 2 => User
 * 3 => Publisher
 */
const checkUserRole = (to, from, next, decodedToken) => {
  switch (decodedToken.role) {
    case 1:
    case 3:
      if (to.path.includes('user')) {
        next({
          path: '/admin',
        });
      } else next();
      break;
    case 2:
      if (to.path.includes('admin')) {
        next({
          path: '/user',
        });
      } else next();
      break;

    default:
      redirectToLoginPage(next);
      break;
  }
};

router.beforeEach((to, from, next) => {
  if (!to.matched.some(m => m.meta.noNeedGuard)) {
    const decodedToken = localStorage.token ?
      jwtDecode(localStorage.token) :
      null;
    if (!decodedToken){
      redirectToLoginPage(next);
    }
    else {
      checkTokenStatus(to, from, next, decodedToken);
      checkUserRole(to, from, next, decodedToken);
    }
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js